import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort } from '@fortawesome/free-solid-svg-icons';

const CallAnalysisExpanded = () => {
  const [hover, setHover] = useState(false);
  const navigate = useNavigate();

  const callData = [];

  const stickyThStyle = {
    position: 'sticky',
    top: 0,
    backgroundColor: '#F4F4F4',
    zIndex: 2,
    fontSize: '0.875rem'
  };

  const HeadCell = ({ children, align = 'start', className = '' }) => (
    <th
      style={stickyThStyle}
      className={`py-2 text-${align} ${className}`}
      scope="col"
    >
      <div
        className={`d-inline-flex align-items-center ${
          align === 'center' ? 'justify-content-center' : ''
        } gap-1`}
      >
        <span>{children}</span>
        <FontAwesomeIcon
          icon={faSort}
          style={{ color: '#2E2868', cursor: 'pointer', fontSize: '0.8em' }}
        />
      </div>
    </th>
  );

  return (
    <div
      className="container-fluid px-4 pt-5 pb-3 d-flex flex-column"
      style={{ minHeight: '100vh' }}
    >
      {/* Header */}
<div className="d-flex justify-content-between align-items-end mb-3">
  <h5
    className="fw-semibold mb-0 ps-2"
    style={{
      color: '#2E2868',
      fontSize: '1.4375rem',
      lineHeight: '1', // keeps the heading tight to align at bottom
    }}
  >
    Call Analysis
  </h5>

  <div className="d-flex align-items-center gap-2">
    <select className="form-select form-select-sm w-auto">
      <option>Yesterday</option>
      <option>Last 7 Days</option>
      <option>Last 30 Days</option>
    </select>

    <button
      className="btn btn-sm"
      style={{
        backgroundColor: '#2E2868',
        color: '#fff',
        border: 'none',
        borderRadius: '4px',
        padding: '6px 12px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
      }}
      onClick={() => navigate('/')}
    >
      ✕ Close
    </button>
  </div>
</div>


      {/* Table Wrapper */}
      <div
        className="border rounded-3 overflow-auto mt-2"
        style={{ maxHeight: 'calc(100vh - 150px)' }}
      >
        <table
          className="table table-sm table-borderless align-middle mb-0"
          style={{
            fontSize: '0.875rem',
            borderCollapse: 'collapse',
            width: '100%'
          }}
        >
          <thead
            className="text-muted small align-middle"
            style={{ height: '36px' }}
          >
            <tr className="border-bottom">
              <HeadCell  className="text-start align-middle py-2 ps-3" >Channel</HeadCell>
              <HeadCell  className="text-start align-middle py-2 ps-3">Date</HeadCell>
              <HeadCell className="text-start align-middle py-2 ps-3">Answered</HeadCell>
              <HeadCell  className="text-start align-middle py-2 ps-3">Unanswered</HeadCell>
              <HeadCell  className="text-start align-middle py-2">Voicemail</HeadCell>
              <HeadCell  className="text-start align-middle py-2 ps-3">Success Rate</HeadCell>
              <HeadCell  className="text-start align-middle py-2 ps-3">Follow-Up Required</HeadCell>
              <HeadCell  className="text-start align-middle py-2 ps-3">Scheduled Appointments</HeadCell>
            </tr>
          </thead>

          <tbody>
            {callData.map((row, idx) => (
              <tr key={idx} className="border-bottom" style={{ height: '36px' }}>
                <td
                  className="text-start align-middle py-2 ps-3"
                  style={{ borderRight: '1px solid #ccc' }}
                >
                  {row.channel}
                </td>
                <td
                  className="text-start align-middle py-2"
                  style={{ borderRight: '1px solid #ccc', padding: '0 12px' }}
                >
                  {row.date}
                </td>
                <td
                  className="text-start align-middle py-2"
                  style={{ borderRight: '1px solid #ccc', padding: '0 12px' }}
                >
                  {row.answered}
                </td>
                <td
                  className="text-start align-middle py-2"
                  style={{ borderRight: '1px solid #ccc', padding: '0 12px' }}
                >
                  {row.unanswered}
                </td>
                <td
                  className="text-start align-middle py-2"
                  style={{ borderRight: '1px solid #ccc', padding: '0 12px' }}
                >
                  {row.voicemail}
                </td>
                <td
                  className="text-start align-middle py-2"
                  style={{ borderRight: '1px solid #ccc', padding: '0 12px' }}
                >
                  {row.successRate}
                </td>
                <td
                  className="text-start align-middle py-2"
                  style={{ borderRight: '1px solid #ccc', padding: '0 12px' }}
                >
                  {row.followUp}
                </td>
                <td
                  className="text-start align-middle py-2"
                  style={{ padding: '0 12px' }}
                >
                  {row.appointments}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CallAnalysisExpanded;
